import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class PdfHistoryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            total: 0,
            page: 1,
            perPage: 15,
            sortField: "created_at",
            sortDir: "desc",
            status: "",
            loading: false,
        };
    }

    componentDidMount() { this.load(); }

    load = () => {
        const { page, perPage, sortField, sortDir, status } = this.state;
        const params = new URLSearchParams({
            page, per_page: perPage, sort_field: sortField, sort_dir: sortDir,
        });
        if (status) params.append("status", status);
        this.setState({ loading: true });
        fetch(`/formatos/pdf_export_history/${this.props.surveyId}?${params.toString()}`)
            .then(r => r.json())
            .then(res => this.setState({
                data: res.data || [],
                total: (res.meta && res.meta.total) || 0,
                loading: false,
            }))
            .catch(() => this.setState({ loading: false }));
    };

    sortBy = (field) => {
        const dir = this.state.sortField === field && this.state.sortDir === "desc" ? "asc" : "desc";
        this.setState({ sortField: field, sortDir: dir, page: 1 }, this.load);
    };

    setStatus = (e) => this.setState({ status: e.target.value, page: 1 }, this.load);

    changePage = (delta) => {
        const next = this.state.page + delta;
        const maxPage = Math.max(1, Math.ceil(this.state.total / this.state.perPage));
        if (next < 1 || next > maxPage) return;
        this.setState({ page: next }, this.load);
    };

    changePerPage = (e) => this.setState({ perPage: parseInt(e.target.value, 10), page: 1 }, this.load);

    badge = (status) => {
        const map = { done: "success", processing: "info", pending: "secondary", error: "danger" };
        return <span className={`badge badge-${map[status] || "secondary"}`}>{status}</span>;
    };

    fmt = (v) => v ? new Date(v).toLocaleString() : "";

    caret = (field) => this.state.sortField === field ? (this.state.sortDir === "desc" ? " ▼" : " ▲") : "";

    render() {
        const { data, total, page, perPage, loading } = this.state;
        const maxPage = Math.max(1, Math.ceil(total / perPage));
        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-xl modal-dialog-centered">
                <ModalHeader toggle={this.props.toggle}>Historial de PDFs</ModalHeader>
                <ModalBody>
                    <div className="d-flex justify-content-between mb-2">
                        <select className="form-control" style={{ width: "auto" }} value={this.state.status} onChange={this.setStatus}>
                            <option value="">Todos los estados</option>
                            <option value="done">Listo</option>
                            <option value="processing">Procesando</option>
                            <option value="pending">Pendiente</option>
                            <option value="error">Error</option>
                        </select>
                        <select className="form-control" style={{ width: "auto" }} value={perPage} onChange={this.changePerPage}>
                            <option value={15}>15 / pág</option>
                            <option value={30}>30 / pág</option>
                            <option value={50}>50 / pág</option>
                        </select>
                    </div>

                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th style={{ cursor: "pointer" }} onClick={() => this.sortBy("created_at")}>Fecha{this.caret("created_at")}</th>
                                <th>Usuario</th>
                                <th style={{ cursor: "pointer" }} onClick={() => this.sortBy("format_pdf_id")}>PDF{this.caret("format_pdf_id")}</th>
                                <th style={{ cursor: "pointer" }} onClick={() => this.sortBy("status")}>Estado{this.caret("status")}</th>
                                <th className="text-right">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5" className="text-center">Cargando...</td></tr>
                            ) : data.length === 0 ? (
                                <tr><td colSpan="5" className="text-center">Sin registros</td></tr>
                            ) : data.map(e => (
                                <tr key={e.id}>
                                    <td>{this.fmt(e.created_at)}</td>
                                    <td>{e.user || "-"}</td>
                                    <td>{e.pdf_name || e.format_pdf_id || "-"}</td>
                                    <td>{this.badge(e.status)}</td>
                                    <td className="text-right">
                                        {e.status === "done" && e.url
                                            ? <a href={e.url} target="_blank" className="btn btn-sm btn-outline-info">Descargar</a>
                                            : <span className="text-muted">-</span>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center">
                        <small>{total} registros</small>
                        <div>
                            <button className="btn btn-sm btn-light mr-2" disabled={page <= 1} onClick={() => this.changePage(-1)}>‹</button>
                            <small>Pág {page} de {maxPage}</small>
                            <button className="btn btn-sm btn-light ml-2" disabled={page >= maxPage} onClick={() => this.changePage(1)}>›</button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default PdfHistoryModal;
